import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import BreadcrumbLayout from 'layouts/BreadcrumbLayout'

import RouteShipmentForm from './RouteShipmentComponents/RouteShipmentForm'

import { useAddRouteShipmentMutation } from 'store/services/routeShipmentApi'
import { useAppMeta } from 'hooks'

const RouteShipmentCreateScreen = () => {
  const navigate = useNavigate()

  const breadcrumbs = [
    { title: 'Route Shipments', path: '/app/crm/route-shipment/list' },
    { title: 'New Route Shipment' }
  ]

  const [createRouteShipment, { isLoading: creatingRouteShipment }] =
    useAddRouteShipmentMutation()

  const handleAddRouteShipment = async (data) => {
    try {
      const { _id } = await createRouteShipment(data).unwrap()
      toast.success('Route Shipment Created!')
      navigate(`/app/crm/route-shipment/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? 'Could not create Route Shipment!'
      )
    }
  }

  useAppMeta('New Route Shipment')

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingRouteShipment}>
      <BreadcrumbLayout.Paper>
        <RouteShipmentForm
          isBusy={creatingRouteShipment}
          onSubmit={handleAddRouteShipment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default RouteShipmentCreateScreen;
